import { render, staticRenderFns } from "./Printfactura.vue?vue&type=template&id=4062e54a&scoped=true&"
import script from "./Printfactura.vue?vue&type=script&lang=js&"
export * from "./Printfactura.vue?vue&type=script&lang=js&"
import style0 from "bootstrap/dist/css/bootstrap.css?vue&type=style&index=0&id=4062e54a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4062e54a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow,VSpacer})
